import { Component, inject } from '@angular/core';
import { BaryTableDataEnum } from 'models/enums/bary-table.enum';
import { QuotationService } from '../../../../services/quotation.service';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-my-quotations-ongoing',
  templateUrl: './my-quotations-ongoing.component.html',
  styleUrls: ['../my-quotations-tab.component.scss'],
})
export class MyQuotationsOngoingComponent {
  protected readonly quotationsService = inject(QuotationService);
  protected readonly QUOTES = BaryTableDataEnum.QUOTES;
  protected readonly FAS = FaDirectiveEnum.FAS;
}
